import axios from 'axios'
import { supportedLocale } from '../locales/LocaleData'

const VERSION = 'api/v1/'

export const qAxios = axios.create({ baseURL: `${process.env.REACT_APP_API_PATH}${supportedLocale}/${VERSION}` })
